import { createFileRoute } from "@tanstack/react-router";
import { ChatSurface } from "~/components/chatbot/chat-surface";
import { useChatController } from "~/components/chatbot/use-chat-controller";
import { seo } from "~/lib/seo";
import * as m from "~/paraglide/messages.js";

export const Route = createFileRoute("/(chat)/chat/")({
  component: ChatPage,
  head: () => {
    const seoData = seo({
      description: m.meta_chat_description(),
      path: "/chat",
      title: m.meta_chat_title(),
    });
    return { links: seoData.links, meta: seoData.meta };
  },
});

function ChatPage() {
  // One controller owns streaming, persistence and conversation controls.
  const { messages, sendMessage, isLoading, clearHistory, stop, error, retry } =
    useChatController();

  // The surface fills the shell edge to edge; the welcome panel and the
  // transcript each carry their own measure, so nothing constrains it here.
  return (
    <ChatSurface
      clearHistory={clearHistory}
      error={Boolean(error)}
      isLoading={isLoading}
      messages={messages}
      retry={retry}
      sendMessage={sendMessage}
      stop={stop}
    />
  );
}
